import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {ApiConnectService} from './api-connect.service';
import {Router} from '@angular/router';
import {UserService} from './user.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ApiService {

  constructor(private http: HttpClient,
              private router: Router,
              private userService: UserService,
              private apiURL: ApiConnectService) {
  }

  getMyGroups(id: string) {
    return this.http.get(this.apiURL.getMyGroups + id + '/groups/', {observe: 'response'});
  }

  getMyTasks() {
    return this.http.get(this.apiURL.getTasks, {observe: 'response'});
  }

}





// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/api.service.ts